/** The column types the item view can write. Every other SIMB-supported type renders read-only. */
export const EDITABLE_COLUMN_TYPES = [
  "text",
  "long_text",
  "numbers",
  "email",
  "phone",
  "link",
  "rating",
  "checkbox",
  "date",
  "hour",
  "timeline",
  "status",
  "dropdown",
  "people",
  "tags",
  "file",
] as const;

export type EditableColumnType = (typeof EDITABLE_COLUMN_TYPES)[number];

export const UNSUPPORTED_EDIT_MESSAGE =
  "Editing this column type isn't supported in SIMB yet. Edit it on the board.";

export const isEditableColumnType = (type: string): type is EditableColumnType =>
  (EDITABLE_COLUMN_TYPES as readonly string[]).includes(type);
